<template>
  <div class="message-box">
    <div class="message-title">
      <svg-icon icon-class="message-success" />
      订单支付成功
    </div>
    <div class="message-button">
      <router-link :to="{ name: 'home' }">
        <el-button type="primary">返回首页</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    payMethod: {
      type: String,
      default: ''
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>
